import(/* webpackMode: "eager" */ "/app/apps/web/components/delices/DelicesHome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingScreen"] */ "/app/apps/web/components/ui/loading.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
